import { getCpfCaepfValidationError } from '@/features/quotes/utils/cpf-caepf-document.util';
import { validateCnpj } from '@/shared/utils';
import { removeFormatRegisterNumber } from '@/shared/utils/remove-format-register-number';

/**
 * Erro de validação do documento do estipulante/subestipulante do Capital
 * Global — CNPJ ou CPF/CAEPF conforme o toggle. Fonte única das mensagens do
 * validator do step 1 e do `validateSubStipulants`.
 */
export function getCapitalGlobalDocumentError(
  documentNumber: string,
  useIndividualDocument: boolean
): string | undefined {
  const doc = (documentNumber || '').trim();

  if (!doc) {
    return useIndividualDocument
      ? 'CPF/CAEPF é obrigatório'
      : 'CNPJ é obrigatório';
  }

  if (!useIndividualDocument) {
    return validateCnpj(doc) ? undefined : 'CNPJ inválido';
  }

  return getCpfCaepfValidationError(doc);
}

/**
 * Variante para exibição em tempo real, sem esperar o primeiro "Próximo": só
 * acusa erro quando o número está completo (14 chars no CNPJ — um CAEPF
 * digitado aqui reprova no DV; 11 ou 14 dígitos no CPF/CAEPF). Antes disso o
 * usuário ainda está digitando e a mensagem seria ruído; campo vazio
 * ("obrigatório") segue por conta do submit.
 */
export function getCapitalGlobalDocumentLiveError(
  documentNumber: string,
  useIndividualDocument: boolean
): string | undefined {
  const clean = removeFormatRegisterNumber(documentNumber);
  const isComplete = useIndividualDocument
    ? clean.length === 11 || clean.length === 14
    : clean.length === 14;

  if (!isComplete) return undefined;

  return getCapitalGlobalDocumentError(documentNumber, useIndividualDocument);
}
